export interface MenuOption {
  value: string;
  label: string;
}

export const SUPPORTO_OPTIONS: MenuOption[] = [
  { value: '', label: '' },
  { value: 'Parete', label: 'Parete' },
  { value: 'Solaio', label: 'Solaio' },
];
